"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SemanticIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _typography = require("../../types/typography");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Icon = require("./Icon");
var _SemanticIconModule = _interopRequireDefault(require("./SemanticIcon.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SemanticIcon = _ref => {
  let {
    semantic = 'neutral',
    classNames,
    size = 'medium',
    ...iconProps
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!iconProps.name && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_SemanticIconModule.default.iconContainer, _SemanticIconModule.default[semantic], _SemanticIconModule.default[size], classNames?.wrapper)
  }, /*#__PURE__*/React.createElement(_Icon.Icon, _extends({}, iconProps, {
    className: (0, _classify.default)(iconProps.className, classNames?.icon),
    color: _typography.TEXT_COLORS[semantic],
    size: size === 'large' ? 'medium' : size
  }))));
};
exports.SemanticIcon = SemanticIcon;